import {CONFIG} from 'config/config';
import axios from 'axios';
import {setCookie, removeCookie} from 'app/lib/cookies';
import {Token} from "app/model/token";
import {ApiUrl} from 'app/static/apiUrls';
import {gtmEventPusher} from "app/services/gtmEventPusher";
import {GTM_EVENTS} from "app/model/gtmEvents";
import {SocialNetworkIdResolver} from 'app/components/sign/socialNetworkId.resolver';
import {mockEnvironment} from "../../app";

const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';
const LOGGED = 'logged';

export class AuthService {
    signIn(credentials, registration = false) {
        this._removeCookies();

        const data = {...credentials, env: mockEnvironment.mode};

        return axios.post(ApiUrl.signIn, data)
            .then((response) => {
                const attributes = response.data.data.attributes;

                if (attributes && attributes.newly_registered) {
                    gtmEventPusher(GTM_EVENTS.REGISTER_MAIL);
                }

                return attributes;
            })
            .then(Token.createFromApiResponse)
            .then(this._saveCookies)
            .then(() => this._redirectToPanel(registration));
    }

    signInSocial(serviceName, accessToken, idToken, registration = false, forwardReferer = false, newsletter = false, firstName=null, lastName=null) {
        this._removeCookies();

        const socialNetworkIdResolver = new SocialNetworkIdResolver();

        const {data, queryParams} = socialNetworkIdResolver.createPayload(serviceName, accessToken, idToken, forwardReferer, newsletter, firstName, lastName);
        data.env = mockEnvironment.mode;

        return axios.post(ApiUrl.signInSn, data, queryParams)
            .then((response) => {
                const attributes = response.data.data.attributes;

                if (attributes && attributes.newly_registered) {
                    gtmEventPusher(GTM_EVENTS[`REGISTER_${serviceName.toUpperCase()}`])
                }

                return attributes;
            })
            .then(Token.createFromApiResponse)
            .then(this._saveCookies)
            .then(() => this._redirectToPanel(registration));
    }

    signUp(credentials, options) {
        this._removeCookies();

        const data = {...options, ...credentials, env: mockEnvironment.mode};

        return axios.post(ApiUrl.signUp, data)
            .then(() => this.signIn({
                username: credentials.email,
                password: credentials.password,
            }, true));
    }

    signUpBusiness(credentials) {
        this._removeCookies();

        return axios.post(ApiUrl.signUpBusiness, credentials);
    }

    /** @private */
    _removeCookies() {
        removeCookie(ACCESS_TOKEN);
        removeCookie(REFRESH_TOKEN);
        removeCookie(LOGGED);
    }

    /** @private */
    _saveCookies(token) {
        setCookie(ACCESS_TOKEN, token.accessToken, 1/24);
        setCookie(REFRESH_TOKEN, token.refreshToken, 1/24);
        setCookie(LOGGED, true, 1/24);
    }

    /** @private */
    _redirectToPanel(registration) {
        if (registration) {
            return window.location = `${CONFIG.PANEL_URL}/order-transfer`;
        }

        return window.location = CONFIG.PANEL_URL;
    }
}
